import { IconTab } from "@/src/components/iconTab";
import {
  AnesthesiologyConsultation,
  Hospitalisation,
  Patient,
} from "@/src/data/allTypes";
import apiFetch from "@/src/utils/apiFetch";
import { getItemId, getUserId, jsonAbstract } from "@/src/utils/utils";
import { FaStethoscope } from "react-icons/fa";
import { getStandardConfidentiality } from "../../patients/confidentialitiesHook";
import openEvolutionItemStandardForm from "../openEvolutionItemStandardForm";
import { CONFIG } from "@/src/data/globalVariables";
import { RiLungsLine, RiMedicineBottleLine } from "react-icons/ri";

function AnesthesiologyConsultationButton({
  patient,
  parent,
  onSave,
}: {
  patient: Patient;
  parent: Hospitalisation;
  onSave: (item: AnesthesiologyConsultation) => void;
}) {
  return (
    <IconTab
      id={"anesthesiologyConsultation"}
      activeTabId={null}
      isHorizontal={true}
      name={"Pré-anesthésie"}
      icon={<RiMedicineBottleLine size={20} />}
      onChange={async () => {
        let referenceId = jsonAbstract(
          getItemId(CONFIG.get()?.anesthesiologyConsultationForm)
        ) as string;
        if (!referenceId)
          throw new Error(
            "Aucun formulaire d'anesthésie trouvé, veuillez contacter l'administrateur"
          );
        let reference = await apiFetch(
          "references",
          "loadOne",
          { referenceId },
          "Erreur lors du chargement de la référence"
        );

        let item: AnesthesiologyConsultation = {
          type: "anesthesiologyConsultation",
          patient,
          creator: getUserId(),
          parent,
          reference,
          refAnswer: {
            patient,
            creator: getUserId(),
            fieldAnswers: [],
            reference,
          },
          confidentiality: getStandardConfidentiality(patient),
          readBy: [getUserId()],
        };

        return await openEvolutionItemStandardForm({
          item,
          patient,
          onConfirm: async (newItem) => {
            newItem = await apiFetch("anesthesiologyConsultations", "addOne", {
              anesthesiologyConsultation: newItem,
            });
            onSave(newItem);
          },
        });
      }}
    />
  );
}

export default AnesthesiologyConsultationButton;
